<button
      type="button"
      class="close"
      data-dismiss="modal"
      aria-label="Close"
      [mat-dialog-close]
      style="margin-top: -12px;"
    >
      <span aria-hidden="true">&times;</span>
    </button>
<mat-selection-list #users [multiple]="false">
    <mat-list-option (click)="select()" *ngFor="let user of data.users" [value]="user.correo">
      {{user.correo}}
    </mat-list-option>
  </mat-selection-list>
  

  